<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getMembershipBenefitTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionMembershipBenefit && permissionMembershipBenefit.permission_id === permission.readWrite"
          @click.native="createMembershipBenefit" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort_order == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort_order == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td  width="5" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td width="10">{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td width="20">
                {{ item.detail_th }}
              </td>
              <td width="30">
                {{ item.rate_th }}
              </td>
              <td width="30">
                {{ item.discount_th }}
              </td>
              <td width="30">{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td  width="5">{{ item.orders }}</td>
              <td  width="5">
                <a @click="showMembershipBenefit(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionMembershipBenefit, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert';
export default {
  name: "MembershipBenefitTable",
  components: {Paginate, InputSearch, IconPencil, CircleButton, InputTextField, Loading },
  data() {
    return {
      title: "Membership benefit",
      isLoading: false,
      headers: [
        { id: 1, text: "No.",icon : null },
        { id: 2, text: "Branch",icon : null },
        { id: 3, text: "Membership",icon : null },
        { id: 4, text: "Rate",icon : null },
        { id: 5, text: "Discount",icon : null },
        { id: 6, text: "Update date",icon : null },
        { id: 7, text: "Order",icon : true },
        { id: 8, text: "Edit",icon : null }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_order : 'desc',
    };
  },
  computed: {
    permissionMembershipBenefit,
  },
  created() {
    this.permission = role;
    this.getMembershipBenefitTable(1);
  },
  methods: {
    goToMembershipBenefitEdit() {
      this.$router.push("/membership-benefit/edit");
    },
    getMembershipBenefitTable(page) {
      this.isLoading = true;
      this.$store.dispatch("MembershipBenefit/getMembershipBenefit", {
        page,
        search : this.search,
        sort_order : this.sort_order
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getMembershipBenefitTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    createMembershipBenefit() {
      this.$store.dispatch("MembershipBenefit/clearFormData").then(() => {
        this.goToMembershipBenefitEdit();
      });
    },
    showMembershipBenefit(id) {
      this.isLoading = true;
      this.$store.dispatch("MembershipBenefit/showMembershipBenefit", id).then(res => {
        if (res.response_code == 200) {
          this.$store
            .dispatch("MembershipBenefit/setFormMembershipBenefit", res.result)
            .then(() => {
              this.goToMembershipBenefitEdit();
            });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
      this.getMembershipBenefitTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
